// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__13sH3","productName":"Table_productName__3tqrq"};